export enum StaticMenuExperimentVariants {
  Control = 'control',
  Treatment = 'treatment',
}
